export const COMPONENT_STATUS = {
  OPEN: 'open',
  COMPLETED: 'completed',
};

export const COMPONENT_STATUS_LABELS = {
  [COMPONENT_STATUS.OPEN]: 'Open',
  [COMPONENT_STATUS.COMPLETED]: 'Completed',
};
